import React from "react";
import AIChatbotTrainingSettingsTabs from "./AIChatbotTrainingSettingsTab";
import AIChatbotFileTrainingIndex from "./AIChatbotFileTrainingIndex";

export default function AIChatbotFileTraining() {
  return (
    <div>
      <AIChatbotTrainingSettingsTabs selectedTab={"File Training"} />
      <AIChatbotFileTrainingIndex allowDrop={true} />
    </div>
  );
}
